import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "psd_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      // Delay slightly to not clash with page load animations
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() }));
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: false, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:bottom-6 md:max-w-md z-[60]
                 rounded-xl bg-slate-900/95 backdrop-blur-xl border border-[#C29B62]/30 shadow-2xl p-5"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-md bg-[#C29B62]/10 border border-[#C29B62]/30 text-[#C29B62] flex items-center justify-center shrink-0">
          <Cookie size={18} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-xs uppercase tracking-[0.25em] text-[#C29B62] mb-1.5">Çerez Bildirimi</div>
          <p className="text-sm text-slate-200 leading-relaxed">
            Platform deneyiminizi iyileştirmek için zorunlu çerezler ve isteğe bağlı analitik çerezler
            kullanıyoruz. Detaylar için{" "}
            <Link to="/cerez-politikasi" className="text-[#C29B62] hover:underline" data-testid="cookie-policy-link">
              Çerez Politikası
            </Link>
            ve{" "}
            <Link to="/kvkk" className="text-[#C29B62] hover:underline" data-testid="cookie-kvkk-link">
              KVKK Aydınlatma Metni
            </Link>
            'ni inceleyebilirsiniz.
          </p>
          <div className="flex items-center gap-2 mt-4">
            <button
              onClick={accept}
              data-testid="cookie-accept"
              className="px-4 py-2 rounded-md bg-[#C29B62] text-slate-950 text-sm font-semibold hover:bg-[#D4AF7A] transition"
            >
              Kabul Et
            </button>
            <button
              onClick={decline}
              data-testid="cookie-decline"
              className="px-4 py-2 rounded-md border border-white/15 text-slate-300 text-sm hover:bg-white/5 transition"
            >
              Sadece zorunlu
            </button>
          </div>
        </div>
        <button
          onClick={decline}
          data-testid="cookie-close"
          className="p-1 rounded text-slate-500 hover:text-white shrink-0"
          aria-label="Kapat"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
